import React, { useContext } from "react";
import { Root as AccordionRoot } from "@radix-ui/react-accordion";
import PropTypes from "prop-types";
import { SidebarContext } from "./SidebarContext";
import { useSelector } from "react-redux";
import { screenBreakpointsSelectors } from "../../../redux/screenBreakpoints";
SidebarContent.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
};
export default function SidebarContent(param) {
    var className = param.className, children = param.children;
    var _useContext = useContext(SidebarContext), expanded = _useContext.expanded, setExpanded = _useContext.setExpanded;
    var overLG = useSelector(screenBreakpointsSelectors.isOver("lg"));
    return overLG ? /*#__PURE__*/ React.createElement(AccordionRoot, {
        className: className,
        type: "multiple",
        value: expanded,
        onValueChange: function(value) {
            return setExpanded(value);
        }
    }, children) : /*#__PURE__*/ React.createElement(AccordionRoot, {
        className: className,
        type: "multiple",
        value: expanded,
        onValueChange: function(value) {
            return setExpanded(value);
        }
    }, children);
}
